import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars, faTimes, faPhone, faMapMarker, faEnvelope, faInfoCircle, faUserAlt, faChevronUp, faWindowClose, faBolt, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faTwitter, faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
export const faSetUp = () => {
    library.add(faTwitter,faBars,faTimes,faPhone,faMapMarker,faEnvelope,faFacebook,faInstagram,faInfoCircle,faUserAlt,faChevronUp,faChevronDown,faWindowClose,faBolt);
}
